import KycService from "../../services/kyc-service";
import { KYC_DEFAULT_FILTER_PAYLOAD } from "./kycDesignShared";
import { getKycAppliedFilterPayload } from "./kycHelpers";

export const parseOrderMasterListResponse = (response) => {
	const success = response?.data?.statusCode === 200 || response?.data?.status === true;
	if (!success) {
		return [];
	}
	const responseData = response.data.responseData || {};
	const orderList = Array.isArray(responseData)
		? responseData
		: responseData.orderMasterLists ||
			responseData.orderMasterList ||
			responseData.kycOrderMasterLists ||
			responseData.orderList ||
			responseData.data ||
			[];
	return Array.isArray(orderList) ? orderList : [];
};

export const parseOrderMasterTableResponse = (response, fallbackPage = 1) => {
	const rows = parseOrderMasterListResponse(response);
	const responseData = response?.data?.responseData || {};
	const totalRecords = Number(
		Array.isArray(responseData) ? rows.length : responseData.totalRecords || rows.length || 0
	);
	const rawPage = Array.isArray(responseData) ? undefined : responseData.currentPage;
	const parsedPage = Number(rawPage);
	const currentPage =
		rawPage !== undefined && rawPage !== null && rawPage !== "" && !Number.isNaN(parsedPage)
			? parsedPage
			: fallbackPage;
	return { rows, totalRecords, currentPage };
};

export const fetchOrderMasterList = async ({
	ispl_product = "",
	customer = "",
	crmGuid = "",
	search = "",
	pageindex = 1,
	pagesize = 10,
	sortcolumn = "createdOn",
	orderBy = "DESC",
	groupCompanyId = "",
} = {}) => {
	const requestData = {
		pageindex,
		pagesize,
		sortcolumn: sortcolumn || "",
		orderBy: orderBy || "",
		search: String(search || "").trim(),
		...KYC_DEFAULT_FILTER_PAYLOAD,
		...getKycAppliedFilterPayload(),
	};
	const trimmedProduct = String(ispl_product || "").trim();
	const trimmedCustomer = String(customer || "").trim();
	const trimmedCrmGuid = String(crmGuid || "").trim();

	if (trimmedProduct) {
		requestData.ispl_product = trimmedProduct;
	}
	if (trimmedCustomer) {
		requestData.customer = trimmedCustomer;
	}
	if (trimmedCrmGuid) {
		requestData.crmGuid = trimmedCrmGuid;
		requestData.CrmGuid = trimmedCrmGuid;
	}

	const trimmedGroupCompanyId = String(groupCompanyId || "").trim();
	if (trimmedGroupCompanyId) {
		requestData.groupcomanyId = trimmedGroupCompanyId;
	}
	const response = await KycService.getKycOrderMasterListAPI(requestData);
	return parseOrderMasterTableResponse(response, pageindex);
};

export const parseOrderDetailListResponse = (response) => {
	const success = response?.data?.statusCode === 200 || response?.data?.status === true;
	if (!success) {
		return [];
	}
	const responseData = response.data.responseData || {};
	const detailList = Array.isArray(responseData)
		? responseData
		: responseData.orderDetailLists ||
			responseData.orderDetailList ||
			responseData.kycOrderDetailLists ||
			responseData.orderDetails ||
			responseData.items ||
			responseData.data ||
			[];
	return Array.isArray(detailList) ? detailList : [];
};

export const parseOrderDetailTableResponse = (response, fallbackPage = 1) => {
	const rows = parseOrderDetailListResponse(response);
	const responseData = response?.data?.responseData || {};
	const totalRecords = Number(
		Array.isArray(responseData) ? rows.length : responseData.totalRecords || rows.length || 0
	);
	const rawPage = Array.isArray(responseData) ? undefined : responseData.currentPage;
	const parsedPage = Number(rawPage);
	const currentPage =
		rawPage !== undefined && rawPage !== null && rawPage !== "" && !Number.isNaN(parsedPage)
			? parsedPage
			: fallbackPage;
	return { rows, totalRecords, currentPage };
};

export const fetchOrderDetailList = async ({
	orderId = "",
	pageindex = 1,
	pagesize = 10,
	sortcolumn = "itemNo",
	orderBy = "ASC",
} = {}) => {
	const requestData = {
		orderId: Number(orderId) || orderId,
		pageindex,
		pagesize,
		sortcolumn: sortcolumn || "",
		orderBy: orderBy || "",
	};
	const response = await KycService.getKycOrderDetailListAPI(requestData);
	return parseOrderDetailTableResponse(response, pageindex);
};
